import { useSelector } from "react-redux";
import { Typography, makeStyles } from "@material-ui/core";

import { COLORS } from "../../../../theme/colors";
import { IconLabelDescription } from "./IconLabelDescription";
import { currencyFormatter, nKilowattFormatter } from "../../../../services/utils";

const useStyles = makeStyles(() => ({
  label: {
    lineHeight: "21px",
    letterSpacing: "0.1px",
    color: COLORS.darks[0][100],
  },
}));

export const InstalledAsset = ({
  iconSrc,
  count,
  name,
  totalPowerCapacity,
  accumulatedRevenues,
  annualRevenues,
}) => {
  const classes = useStyles();
  const currencySymbol = useSelector((state) => state.auth.user.currency.symbol);

  return (
    <IconLabelDescription iconSrc={iconSrc} label={`${count || 0} ${name}`}>
      <Typography variant="body1" className={classes.label}>
        Total Capacity {nKilowattFormatter(totalPowerCapacity)}
      </Typography>
      <Typography variant="body1" className={classes.label}>
        Acc. Revenues {currencyFormatter(accumulatedRevenues, currencySymbol)}
      </Typography>
      <Typography variant="body1" className={classes.label}>
        Annual Revenues {currencyFormatter(annualRevenues, currencySymbol)}/Year
      </Typography>
    </IconLabelDescription>
  );
};
